import { ActivatedRoute, Router } from "@angular/router";
import { ApiService } from "../api.service";
import { CommonService } from "../common.service";
var GraduationNewComponent = (function () {
    function GraduationNewComponent(route, router, apiService, commonService) {
        this.route = route;
        this.router = router;
        this.apiService = apiService;
        this.commonService = commonService;
    }
    GraduationNewComponent.prototype.ngOnInit = function () {
        var _this = this;
        var that = this;
        this.levelArray = [];
        this.nameArray = [];
        this.preLevelArray = [];
        this.postLevelArray = [];
        this.route.params.subscribe(function (params) {
            _this.learningTourId = params['learningTourId'];
            _this.apiService.ajax({
                'type': 'get',
                'url': '/api/learningtour/' + _this.learningTourId + '/graduation/0',
                'data': {}
            }).subscribe(function (result) {
                _this.data = result;
                _this.data.learningPaths.forEach(function (item, index) {
                    if (item.postSurveyLevel != '' && item.postSurveyLevel != 0) {
                        that.levelArray.push(item);
                    }
                });
                _this.levelArray.forEach(function (item, index) {
                    that.nameArray.push({
                        name: item.abilityName,
                        max: 7
                    });
                    that.preLevelArray.push(item.preSurveyLevel);
                    that.postLevelArray.push(item.postSurveyLevel);
                });
                _this.characterReport = _this.data.characterReport;
                if (_this.levelArray.length > 2) {
                    _this.setChart();
                }
            });
        });
        this.apiService.ajax({
            'type': 'get',
            'url': '/sr/onceino/1001',
            'data': {}
        }).subscribe(function (result) {
            if (!result) {
                _this.apiService.ajax({
                    'type': 'post',
                    'url': '/sr/onceino/1001',
                    'data': {}
                }).subscribe();
            }
        });
        /*this.data = this.getMockData();
        this.data.learningPaths.forEach(function (item,index) {
            if(item.postSurveyLevel!=''&&item.postSurveyLevel!=0){
              that.levelArray.push(item);
            }
        });
    
        this.levelArray.forEach(function (item,index) {
            that.nameArray.push({
                name: item.abilityName,
                max: 7
            });
            that.preLevelArray.push(item.preSurveyLevel);
            that.postLevelArray.push(item.postSurveyLevel);
        });
        this.characterReport = this.data.characterReport;
    
        this.setChart();*/
    };
    GraduationNewComponent.prototype.ngAfterViewInit = function () {
        this.commonService.initPage({
            'backgroundColor': '#424d84'
        });
        var that = this;
        if (this.data) {
            $("#headPortrait").css("background-image", "url(" + this.data.headimgurl + ")");
        }
        else {
            var headerInterval = setInterval(function () {
                if (that.data) {
                    $("#headPortrait").css("background-image", "url(" + that.data.headimgurl + ")");
                    clearInterval(headerInterval);
                }
            }, 100);
        }
    };
    GraduationNewComponent.prototype.onCloseBtnReportClick = function () {
        if (this.characterReport && this.characterReport.id) {
            $('#dnaReport').fadeOut();
            $('#closeBtnReport2').fadeOut();
            $('#shade').fadeOut();
        }
        else {
            $('#noDnaReport').fadeOut();
            $('#closeBtnReport2').fadeOut();
            $('#shade').fadeOut();
        }
    };
    GraduationNewComponent.prototype.onPersonalitiesBtnClick = function () {
        if (this.characterReport && this.characterReport.id) {
            $('#dnaReport').fadeIn();
            $('#closeBtnReport2').fadeIn();
            $('#shade').fadeIn();
        }
        else {
            $('#noDnaReport').fadeIn();
            $('#closeBtnReport2').fadeIn();
            $('#shade').fadeIn();
        }
    };
    GraduationNewComponent.prototype.close = function () {
        var link = ['learning-map'];
        this.router.navigate(link);
    };
    GraduationNewComponent.prototype.setChart = function () {
        var that = this;
        jQuery.getScript("/assets/js/echarts.min.js", function (data, status, jqxhr) {
            if (true) {
                var myChart = echarts.init(document.getElementById('radar'));
                var option = {
                    radar: {
                        name: {
                            textStyle: {
                                color: '#ffffff',
                                fontSize: 14
                            }
                        },
                        splitArea: {
                            show: false
                        },
                        splitLine: {
                            lineStyle: {
                                width: 1,
                                opacity: 0.3,
                                color: '#d1d2d5',
                            }
                        },
                        axisLine: {
                            show: false
                        },
                        indicator: that.nameArray
                    },
                    series: [
                        {
                            type: 'radar',
                            itemStyle: {
                                normal: {
                                    lineStyle: {
                                        color: '#6ed9ff',
                                        width: 2
                                    }
                                }
                            },
                            data: [
                                {
                                    value: that.postLevelArray,
                                    symbol: 'none',
                                    areaStyle: {
                                        normal: {
                                            opacity: 0.4,
                                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                                    offset: 0,
                                                    color: '#3d6d92'
                                                }, {
                                                    offset: 1,
                                                    color: '#63c0f7'
                                                }])
                                        }
                                    }
                                }
                            ]
                        },
                        {
                            type: 'radar',
                            itemStyle: {
                                normal: {
                                    lineStyle: {
                                        color: '#565fb3',
                                        width: 2
                                    }
                                }
                            },
                            data: [
                                {
                                    value: that.preLevelArray,
                                    symbol: 'none',
                                    areaStyle: {
                                        normal: {
                                            opacity: 0.4,
                                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                                    offset: 0,
                                                    color: '#7c64ff'
                                                }, {
                                                    offset: 1,
                                                    color: '#5141a2'
                                                }])
                                        }
                                    }
                                }
                            ]
                        }
                    ]
                };
                myChart.setOption(option);
            }
        });
    };
    return GraduationNewComponent;
}());
export { GraduationNewComponent };



// WEBPACK FOOTER //
// ./src/app/graduation-new/graduation-new.component.ts.pre-build-optimizer.js